var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedMgmtOccupancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z",
    fill: "#DBEAFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 26.6668V20.0002C12.5 19.5581 12.6756 19.1342 12.9882 18.8217C13.3007 18.5091 13.7246 18.3335 14.1667 18.3335H25.8333C26.2754 18.3335 26.6993 18.5091 27.0118 18.8217C27.3244 19.1342 27.5 19.5581 27.5 20.0002V26.6668",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1665 18.3335V15.0002C14.1665 14.5581 14.3421 14.1342 14.6547 13.8217C14.9672 13.5091 15.3911 13.3335 15.8332 13.3335H24.1665C24.6085 13.3335 25.0325 13.5091 25.345 13.8217C25.6576 14.1342 25.8332 14.5581 25.8332 15.0002V18.3335",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25H27.5",
    stroke: "#155DFC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedMgmtOccupancy);
export default __webpack_public_path__ + "static/media/bedMgmtOccupancy.679b7b24a9af451273bd9dd5d72aeb63.svg";
export { ForwardRef as ReactComponent };